import { render, staticRenderFns } from "./LevelPaymentBetaNotice.vue?vue&type=template&id=44384eb5&scoped=true"
import script from "./LevelPaymentBetaNotice.vue?vue&type=script&lang=js"
export * from "./LevelPaymentBetaNotice.vue?vue&type=script&lang=js"
import style0 from "./LevelPaymentBetaNotice.vue?vue&type=style&index=0&id=44384eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44384eb5",
  null
  
)

export default component.exports